const PrivacyModal = () => {
    
return (
       
<div className="modal fade " id="privacyModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="staticBackdropLabel">Privacy Policy</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body text-start">
        <h3>Welcome to Trailfinders’ privacy notice.</h3><br/><br/>
<p >
Trailfinders respects your privacy and is committed to protecting your personal data. This privacy notice will inform you as to how we look after your personal data when you visit our website (regardless of where you visit it from) or when you otherwise provide personal data to us via other means (such as over the telephone) and tell you about your privacy rights and how the law protects you.<br/><br/>

This privacy notice is provided in a layered format, so that you can easily click through to the specific areas set out below. Alternatively you can download a pdf version of the policy <a href="https://cdn.trailfinders.com/static/codesource/privacy/privacypolicy.pdf">here.</a><br/><br/>

Please also use refer to the Glossary that we have set out at the end of the Policy, if there is any terminology used in this privacy notice that you are unfamiliar with or that you don’t fully understand.</p>

<div>
<div className="accordion accordion-flush" id="accordionFlushExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingOne">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
        1. Important information and who we are
      </button>
    </h2>
    <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body text-start">
      <p>Purpose of this privacy notice<br/><br/>
This privacy notice aims to give you information on how Trailfinders collects and processes your personal data, including any data you may provide through this website or via any other means (such as over the telephone) when you purchase travel services, when you sign up to our magazine, when you make an enquiry via our website, when you take part in a competition etc.<br/><br/>

This website is not intended for children and the only circumstances in which we collect data relating to children, is where you make a booking of travel services and you have children in your party.<br/><br/>

It is important that you read this privacy notice together with any other privacy notice or fair processing notice we may provide on specific occasions when we are collecting or processing personal data about you so that you are fully aware of how and why we are using your data. This privacy notice supplements the other notices and is not intended to override them.<br/><br/>

Controller<br/><br/>
Trailfinders Limited is the controller and responsible for your personal data (collectively referred to as "Trailfinders", "we", "us" or "our" in this privacy notice).<br/><br/>

We have appointed a data protection officer (DPO) who is responsible for overseeing questions in relation to this privacy notice. If you have any questions about this privacy notice, including any requests to exercise your legal rights, please contact the DPO using the details set out below.<br/><br/>

Contact details<br/><br/>
Our full details are:</p>
<table className="table" id="contacttable">
  <tbody>
    <tr>
      <td>Full name of legal entity:</td>
      <td>Trailfinders Limited</td>
    </tr>
    <tr>
      <td>Name or title of DPO:</td>
      <td>Darren Dods</td>
    </tr>
    <tr>
      <td>Email address:</td>
      <td>
        <aside><a href="mailto:GDPR@trailfinders.com" className="text-dark">GDPR@trailfinders.com</a></aside>
      </td>
    </tr>
    <tr>
      <td>Postal address:</td>
      <td>48 Earls Court Road, London, W8 6FT</td>
    </tr>
    <tr>
      <td>Telephone number:</td>
      <td>0207 084 6500</td>
    </tr>
  </tbody>
</table>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingTwo">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
        2. The data we collect about you
      </button>
    </h2>
    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
      <section className="row">
                    <div className="col-12">
                      <section className="row">
                        <p>Personal data, or personal information, means any
                          information about an individual from which that person
                          can be identified. It does not include data where the
                          identity has been removed (anonymous data).</p>
                        <p>We may collect, use, store and transfer different
                          kinds of personal data about you which we have grouped
                          together follows:</p>
                        <div>
                          <ol className="text-strong" type="A">
                            <li>Identity Data
                              <p>This includes data relating specifically to
                                your identity, such as your first name, maiden
                                name, last name, username or similar identifier,
                                marital status, title, date of birth and gender.</p>
                            </li>
                            <li>Contact Data
                              <p>This includes data relating to how you may be
                                contacted, such as your billing address,
                                delivery address, email address and telephone
                                numbers.</p>
                            </li>
                            <li>Financial Data
                              <p>This include data relating to your means and
                                methods of payment, such as your bank account
                                and payment card details.
                              </p>
                            </li>
                            <li>Transaction Data
                              <p>This includes data relating to the transactions
                                you have carried out with us, such as details
                                about payments to and from you and other details
                                of products and services you have purchased from
                                us.</p>
                            </li>
                            <li>Technical Data
                              <p>This includes more technical data that we may
                                obtain when you make use of our website, such as
                                your internet protocol (IP) address, your login
                                data, browser type and version, time zone
                                setting and location, browser plug-in types and
                                versions, operating system and platform and
                                other technology on the devices you use to
                                access this website.
                              </p>
                            </li>
                            <li>Usage Data
                              <p>This includes information about how you use our
                                website, products and services.</p>
                            </li>
                            <li>Marketing and Communications Data
                              <p>This includes your preferences in relation to
                                whether or not you want to receive marketing
                                from us and our third parties and also your
                                communication preferences.</p>
                            </li>
                          </ol>
                        </div>
                        <p>
                          We also collect, use and share
                          <strong>Aggregated Data</strong>
                          such as statistical or demographic data for any
                          purpose. Aggregated Data may be derived from your
                          personal data but is not considered personal data in
                          law as this data does not directly or indirectly
                          reveal your identity. For example, we may aggregate
                          your Usage Data to calculate the percentage of users
                          accessing a specific website feature. However, if we
                          combine or connect Aggregated Data with your personal
                          data so that it can directly or indirectly identify
                          you, we will treat the combined data as personal data
                          which will be used in accordance with this privacy
                          notice.
                        </p>
                        <h5 className="text-strong">Special Categories of Personal
                          Data</h5>
                        <p>We collect the following special categories of
                          personal data about you.
                        </p>
                        <p className="nomarginbottom">Details about your:</p>
                        <div>
                          <ul className="text-strong" style={{listStyleType:"disc"}}>
                            <li>Dietary requirements which may disclose your
                              religious or philosophical beliefs</li>
                            <li>Health</li>
                          </ul>
                        </div>
                        <p>We collect and process the above data only where it
                          is strictly necessary to do so in order to deliver the
                          travel service that you have purchased. Furthermore,
                          we will only collect and process the above special
                          categories of sensitive personal data where you have
                          provided us with your explicit consent to do so.</p>
                        <p>You are not under any obligation to consent to us
                          processing your sensitive personal data. However,
                          without your consent, we won’t be able to make the
                          necessary arrangements to provide the travel services
                          that you have booked or are attempting to book. As a
                          result, if you do not provide your consent, we will be
                          unable to proceed with your booking.
                        </p>
                        <p>If you are happy to consent to our use of your
                          sensitive personal data, you will also be able to
                          withdraw your consent at any time. However, as this
                          will prevent us or (where we are acting as an agent)
                          the supplier of your chosen travel service from
                          providing the travel service you have booked, we (or
                          the supplier of your chosen arrangements) will be
                          required to treat any withdrawal of consent as a
                          cancellation of your booking and the cancellation
                          charges set out in our
                          <a href="/booking-conditions" target="_new" className="text-dark text-strong">Booking Terms and Conditions</a>
                          will become payable.</p>
                        <h5 className="text-strong">If you fail to provide personal
                          data</h5>
                        <p>Where we need to collect personal data by law or
                          under the terms of a contract we have with you and you
                          fail to provide that data when requested, we may not
                          be able to perform the contract we have or are trying
                          to enter into with you.
                        </p>
                        <p>Where we are acting as an agent and we need to
                          collect personal data to enter you into a contract
                          with the supplier of your chosen travel arrangements,
                          we may not be able to take steps to enter you into
                          that contract if you fail to provide the data when
                          requested.
                        </p>
                        <p>In other words, where we require details from you in
                          order to provide you with your chosen travel services,
                          if you do not provide us with the necessary details
                          then we will not be able to provide (or arrange for
                          the provision of) the services you have booked or are
                          attempting to book.
                        </p>
                        <p>In this case, depending upon when you fail to provide
                          the necessary data, we may either not be able to
                          process your booking or we may have to cancel your
                          booking, in which case we will treat this as a
                          ‘cancellation by you’ in accordance with our
                          <a href="/booking-conditions" target="_new" className="text-dark text-strong">Booking Terms and Conditions</a>. We will notify you
                          if we are unable to process a booking or are required
                          to cancel a booking for this reason.</p>
                      </section>
                    </div>
                  </section>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingThree">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
        3. How your personal data is collected
      </button>
    </h2>
    <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
      <section className="row">
                    <div className="col-12">
                      <section className="row">
                        <p>We use different methods to collect data from and
                          about you including through:</p>
                        <div>
                          <ol type="A">
                            <li>Direct interactions
                              <p>You may give us your Identity, Contact and
                                Financial Data by filling in forms or by
                                corresponding with us by post, phone, email or
                                otherwise. This includes personal data you
                                provide when you:</p>
                                <ul style={{listStyleType:'disc'}}>
                                <li>make a booking of travel services</li>
                                <li>request contact from us via our website</li>
                                <li>subscribe to our e-newsletter, magazine or
                                  other publications</li>
                                <li>request marketing to be sent to you</li>
                                <li>enter a competition, promotion or survey; or</li>
                                <li>give us some feedback.</li>
                              </ul>
                            </li>
                            <li>Automated technologies or interactions
                              <p>As you interact with our website, we may
                                automatically collect Technical Data about your
                                equipment, browsing actions and patterns.</p>
                              <p>We collect this personal data by using cookies,
                                and other similar technologies. Please see our
                                <a href="/privacy/cookie-policy" target="_new" className="text-dark text-strong">cookie policy</a>
                                for further details.</p>
                            </li>
                            <li>Third parties
                              <p>We may receive personal data about you from
                                various third parties as set out below:</p>
                              <ul style={{listStyleType:'disc'}}>
                                <li>Technical Data from the following parties
                                  <p className="subtext">(i) analytics providers
                                    such as Google, based outside the EU and</p>
                                  <p className="subtext">(ii) advertising networks
                                    based inside OR outside the EU</p>
                                </li>
                              </ul>
                            </li>
                          </ol>
                        </div>
                      </section>
                    </div>
                  </section>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingFour">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
       4. How we use your personal data
      </button>
    </h2>
    <div id="flush-collapseFour" className="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
      <section className="row">
                        <p>We will only use your personal data when the law
                          allows us to. Most commonly, we will use your personal
                          data in the following circumstances:</p>
                        <div>
                          <ul style={{listStyleType:'disc'}}>
                            <li>Where we need to perform the contract we are
                              about to enter into or have entered into with you.</li>
                            <li>Where we need to take steps to enter you into a
                              contract with the supplier of your chosen travel
                              services, where we are acting in an agency
                              capacity.
                            </li>
                            <li>Where it is necessary for our legitimate
                              interests (or those of a third party) and your
                              interests and fundamental rights do not override
                              those interests.</li>
                            <li>Where we need to comply with a legal or
                              regulatory obligation.</li>
                          </ul>
                        </div>
                        <p>Generally we do not rely on consent as a legal basis
                          for processing your personal data.</p>
                        <h6>Purposes for which we will use your personal data</h6>
                        <p>We have set out below, in a table format, a
                          description of all the ways we plan to use your
                          personal data, and which of the legal bases we rely on
                          to do so. We have also identified what our legitimate
                          interests are where appropriate.
                        </p>
                        <p>Note that we may process your personal data for more
                          than one lawful ground depending on the specific
                          purpose for which we are using your data. Please
                          <span className="contactlink">contact us</span>
                          if you need details about the specific legal ground we
                          are relying on to process your personal data where
                          more than one ground has been set out in the table
                          below.</p>
                        <table id="purposetable">
                          <tbody>
                            <tr>
                              <th style={{width:'40%'}}>Purpose/Activity</th>
                              <th style={{width:'20%'}}>Type of data</th>
                              <th style={{width:'40%'}}>Lawful basis for processing
                                including basis of legitimate interest</th>
                            </tr>

                            <tr>
                              <td>To register you as a new customer.</td>
                              <td>(a) Identity;<br/>(b) Contact.</td>
                              <td>Performance of a contract with you.</td>
                            </tr>

                            <tr>
                              <td>To process and deliver your booking including:
                                (a) Manage payments, fees and charges;<br/>(b) Collect and recover money owed to us.</td>
                              <td>(a) Identity;<br/>(b) Contact;<br/>(c)
                                Financial;<br/>(d) Transaction;<br/>(e)
                                Marketing and Communications.</td>
                              <td>(a) Performance of a contract with you;<br/>(b) Necessary for our legitimate interests (to
                                recover debts due to us).
                              </td>
                            </tr>

                            <tr>
                              <td>To manage our relationship with you which will
                                include:<br/>
                                (a) Notifying you about changes to our terms or
                                privacy policy;<br/>
                                (b) Asking you to leave a review or take a
                                survey.</td>
                              <td>(a) Identity;<br/>(b) Contact;<br/>(c)
                                Marketing and Communications.</td>
                              <td>(a) Performance of a contract with you;<br/>
                                (b) Necessary to comply with a legal obligation;<br/>
                                (c) Necessary for our legitimate interests (to
                                keep our records updated and to study how
                                customers use our products/services).</td>
                            </tr>

                            <tr>
                              <td>To enable you to partake in a prize draw,
                                competition or complete a survey.</td>
                              <td>(a) Identity;<br/>(b) Contact;<br/>(c)
                                Usage;<br/>(d) Marketing and Communications.</td>
                              <td>(a) Performance of a contract with you;<br/>
                                (b) Necessary for our legitimate interests (to
                                study how customers use our products/services,
                                to develop them and grow our business).
                              </td>
                            </tr>

                            <tr>
                              <td>To administer and protect our business and
                                this website (including troubleshooting, data
                                analysis, testing, system maintenance, support,
                                reporting and hosting of data).</td>
                              <td>(a) Identity;<br/>(b) Contact;<br/>(c)
                                Technical.</td>
                              <td>(a) Necessary for our legitimate interests
                                (for running our business, provision of
                                administration and IT services, network
                                security, to prevent fraud and in the context of
                                a business reorganisation or group restructuring
                                exercise);<br/>
                                (b) Necessary to comply with a legal obligation.
                              </td>
                            </tr>

                            <tr>
                              <td>To deliver relevant website content and
                                advertisements to you and measure or understand
                                the effectiveness of the advertising we serve to
                                you</td>
                              <td>(a) Identity;<br/>(b) Contact;<br/>(c)
                                Usage;<br/>(d) Marketing and Communications.</td>
                              <td>Necessary for our legitimate interests (to
                                study how customers use our products/services,
                                to develop them, to grow our business and to
                                inform our marketing strategy)</td>
                            </tr>

                            <tr>
                              <td>To use data analytics to improve our website,
                                products/services, marketing, customer
                                relationships and experiences</td>
                              <td>(a) Technical<br/>(b) Usage</td>
                              <td>Necessary for our legitimate interests (to
                                define types of customers for our products and
                                services, to keep our website updated and
                                relevant, to develop our business and to inform
                                our marketing strategy)</td>
                            </tr>

                            <tr>
                              <td>To make suggestions and recommendations to you
                                about goods or services that may be of interest
                                to you</td>
                              <td>(a) Identity;<br/>(b) Contact;<br/>(c)
                                Usage;<br/>(d) Marketing and Communications.</td>
                              <td>Necessary for our legitimate interests (to
                                develop our products/services and grow our
                                business)</td>
                            </tr>

                            <tr>
                              <td>To monitor our communications with you in
                                order to check any instructions given to us, for
                                training purposes, for crime prevention, to
                                improve the quality of our customer service and
                                to defend legal claims.</td>
                              <td>(a) Identity;<br/>(b) Contact;<br/>(c)Technical
                              </td>
                              <td>(a) Necessary for our legitimate interests (to
                                assist us in training our employees and defend
                                our business in the event of a claim).<br/>
                                (b) Necessary to comply with a legal obligation;
                              </td>
                            </tr>

                            <tr>
                              <td>For the establishment, exercise or defence of
                                legal claims, whether in court proceedings or in
                                an administrative or out-of-court procedure</td>
                              <td>(a) Identity<br/>(b) Contact<br/>(c)
                                Financial<br/>(d) Transaction<br/>(e)
                                Technical<br/>(f) Usage<br/>(g) Marketing</td>
                              <td>Necessary for our legitimate interests
                                (protection and assertion of our legal rights,
                                your legal rights and the legal rights of
                                others)</td>
                            </tr>

                            <tr>
                              <td>For the purposes of obtaining or maintaining
                                insurance coverage, managing risks, or obtaining
                                professional advice</td>
                              <td>(a) Identity<br/>(b) Contact<br/>(c)
                                Financial<br/>(d) Transaction<br/>(e)
                                Technical</td>
                              <td>Necessary for our legitimate interests (the
                                proper protection of our business against risks)</td>
                            </tr>
                          </tbody></table>
                        <h5 className="text-strong">Marketing</h5>
                        <p>We strive to provide you with choices regarding
                          certain personal data uses, particularly around
                          marketing and advertising.</p>
                        <p>We have established the following personal data
                          control mechanisms:</p>
                        <h5 className="text-strong">Promotional offers from us </h5>
                        <p>We may use your Identity, Contact, Technical, Usage
                          and Profile Data to form a view on what we think you
                          may want or need, or what may be of interest to you.
                          This is how we decide which products, services and
                          offers may be relevant for you (we call this
                          marketing).
                        </p>
                        <h5 className="text-strong">Opting out</h5>
                        <p>You can ask us or third parties to stop sending you
                          marketing messages at any time by following the
                          opt-out links on any marketing message sent to you or
                          by
                          <span className="contactlink">contacting us</span>
                          at any time.
                        </p>
                        <p>Where you opt out of receiving these marketing
                          messages, this will not apply to personal data that
                          you have provided to us as a result of a purchase of
                          travel services or other such transactions.</p>
                        <h5 className="text-strong">Monitoring communications</h5>
                        <p>We may monitor, record, store and use any telephone,
                          email or other communication with you in order to
                          check any instructions given to us, for training
                          purposes, for crime prevention and to improve the
                          quality of our customer service.</p>
                        <h5 className="text-strong">Cookies</h5>
                        <p>You can set your browser to refuse all or some
                          browser cookies, or to alert you when websites set or
                          access cookies. If you disable or refuse cookies,
                          please note that some parts of this website may become
                          inaccessible or not function properly. For more
                          information about the cookies we use, please see our
                          <a href="/privacy/cookie-policy" target="_new" className="text-dark text-strong">cookie policy</a>
                          for further details.</p>
                        <h5 className="text-strong">Change of purpose </h5>
                        <p>We will only use your personal data for the purposes
                          for which we collected it, unless we reasonably
                          consider that we need to use it for another reason and
                          that reason is compatible with the original purpose.
                          If you wish to get an explanation as to how the
                          processing for the new purpose is compatible with the
                          original purpose, please
                          <span className="contactlink">contact us</span>.
                        </p>
                        <p>If we need to use your personal data for an unrelated
                          purpose, we will notify you and we will explain the
                          legal basis which allows us to do so.</p>
                        <p>Please note that we may process your personal data
                          without your knowledge or consent, in compliance with
                          the above rules, where this is required or permitted
                          by law.</p>
                      </section>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingFive">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
        5. Disclosures of your personal data
      </button>
    </h2>
    <div id="flush-collapseFive" className="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
      <section className="row">
                        <p>We may have to share your personal data with the
                          parties set out below for the purposes set out in the
                          table in paragraph 4 above.</p>
                        <div>
                          <ol type="A" className="olnormaltxt">
                            <li>Internal Third Parties as set out in the
                              Glossary.
                            </li>
                            <li>External Third Parties as set out in the
                              Glossary.
                            </li>
                            <li>Third parties to whom we may choose to sell,
                              transfer, or merge parts of our business or our
                              assets. Alternatively, we may seek to acquire
                              other businesses or merge with them. If a change
                              happens to our business, then the new owners may
                              use your personal data in the same way as set out
                              in this privacy notice.
                            </li>
                          </ol>
                        </div>
                        <p>We require all third parties to respect the security
                          of your personal data and to treat it in accordance
                          with the law. We do not allow our third-party service
                          providers to use your personal data for their own
                          purposes and only permit them to process your personal
                          data for specified purposes and in accordance with our
                          instructions.</p>
                      </section>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingSix">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
        6. International transfers
      </button>
    </h2>
    <div id="flush-collapseSix" className="accordion-collapse collapse" aria-labelledby="flush-headingSix" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
      <section className="row">
                        <p>Many of our external third parties are based outside
                          the European Economic Area (EEA) so their processing
                          of your personal data will involve a transfer of data
                          outside the EEA.</p>
                        <p>Where you have requested a booking for travel
                          arrangements which are located or otherwise due to be
                          fulfilled outside the EEA, we will have to transfer
                          your personal data to the suppliers fulfilling or
                          providing those travel arrangements outside the EEA in
                          order to make your booking and for those suppliers to
                          be able to provide you with the travel arrangements
                          you have booked. Where we are unable to rely on one of
                          the safeguards outlined below when transferring data
                          to those suppliers outside the EEA, we will rely on
                          the derogation under Article 49 of the GDPR in order
                          to transfer your personal data to countries outside
                          the EEA (as the transfer relates to the performance of
                          a contract for your benefit), and you hereby permit us
                          to do so. You also acknowledge that where your
                          personal data is transferred outside the EEA, controls
                          on data protection may not be as wide as the legal
                          requirements within the EEA.</p>
                        <p>For all other transfers of data, whenever your
                          personal data is transferred outside the EEA, we
                          ensure a similar degree of protection is afforded to
                          it by ensuring at least one of the following
                          safeguards is implemented:
                        </p>
                        <div>
                          <ul>
                            <li>We will only transfer your personal data to
                              countries that have been deemed to provide an
                              adequate level of protection for personal data by
                              the European Commission. For further details, see
                              <a href="https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/adequacy-protection-personal-data-non-eu-countries_en" target="_new" className="text-dark text-strong">European Commission: Adequacy of the protection
                                of personal data in non-EU countries</a>.</li>
                            <li>Where we use certain service providers, we may
                              use specific contracts approved by the European
                              Commission which give personal data the same
                              protection it has in Europe. For further details,
                              see
                              <a href="https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/model-contracts-transfer-personal-data-third-countries_en" target="_new" className="text-dark text-strong">European Commission: Model contracts for the
                                transfer of personal data to third countries.</a></li>
                            <li>Where we use providers based in the US, we may
                              transfer data to them if they are part of the
                              Privacy Shield which requires them to provide
                              similar protection to personal data shared between
                              the Europe and the US. For further details, see
                              <a href="https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/eu-us-privacy-shield_en" target="_new" className="text-dark text-strong">European Commission: EU-US Privacy Shield.</a></li>
                          </ul>
                        </div>
                        <p>Please
                          <span className="contactlink"> contact us </span>
                          if you want further information on the specific
                          mechanism used by us when transferring your personal
                          data out of the EEA.
                        </p>
                      </section>
     </div>
    </div>
  </div>

  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingSeven">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSeven" aria-expanded="false" aria-controls="flush-collapseSeven">
        7. Data security
      </button>
    </h2>
    <div id="flush-collapseSeven" className="accordion-collapse collapse" aria-labelledby="flush-headingSeven" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
      <section className="row">
                        <p>We have put in place appropriate security measures to
                          prevent your personal data from being accidentally
                          lost, used or accessed in an unauthorised way, altered
                          or disclosed. In addition, we limit access to your
                          personal data to those employees, agents, contractors
                          and other third parties who have a business need to
                          know. They will only process your personal data on our
                          instructions and they are subject to a duty of
                          confidentiality.
                        </p>
                        <p>We have put in place procedures to deal with any
                          suspected personal data breach and will notify you and
                          any applicable regulator of a breach where we are
                          legally required to do so.</p>
                      </section>
       </div>
    </div>
  </div>

  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingEight">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseEight" aria-expanded="false" aria-controls="flush-collapseEight">
        8. Data retention
      </button>
    </h2>
    <div id="flush-collapseEight" className="accordion-collapse collapse" aria-labelledby="flush-headingEight" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
      <section className="row">
                    <div className="col-12">
                      <section className="row">
                        <h5>How long will you use my personal data for?</h5>
                        <p>We will only retain your personal data for as long as
                          reasonably necessary to fulfil the purposes we
                          collected it for, including for the purposes of
                          satisfying any legal, regulatory, tax, accounting, or
                          reporting requirements.</p>
                        <p>To determine the appropriate retention period for
                          personal data, we consider the amount, nature, and
                          sensitivity of the personal data, the potential risk
                          of harm from unauthorised use or disclosure of your
                          personal data, the purposes for which we process your
                          personal data and whether we can achieve those
                          purposes through other means, and the applicable legal
                          regulatory, tax, accounting or other requirements. We
                          will review periodically the information we hold and
                          delete it securely, or in some cases anonymise it,
                          when there is no longer a legal, business or customer
                          need for it to be retained. Should you stop
                          interacting with us as a client, we will remove or
                          anonymise your information after 7 years.</p>
                        <p>If you require any further details about our
                          retention periods, you can request the same by
                          <span className="contactlink"> contacting us. </span>
                        </p>
                        <p>In some circumstances you can ask us to delete your
                          data: see
                          <span className="erasurelink">Request erasure</span>
                          below for further information.
                        </p>
                        <p>In some circumstances we may anonymise your personal
                          data (so that it can no longer be associated with you)
                          for research or statistical purposes in which case we
                          may use this information indefinitely without further
                          notice to you.</p>
                      </section>
                    </div>
                  </section>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingNine">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseNine" aria-expanded="false" aria-controls="flush-collapseNine">
        9. Your legal rights
      </button>
    </h2>
    <div id="flush-collapseNine" className="accordion-collapse collapse" aria-labelledby="flush-headingNine" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
      <section className="row">
                    <div className="col-12">
                      <section className="row">
                        <p>Under certain circumstances, you have rights under
                          data protection laws in relation to your personal
                          data. Please click on the links below to find out more
                          about these rights:
                        </p>
                        <div>
                          <ol type="A" className="olnormaltxt" id="glossarylinks">
                            <li>Request access to your personal data.</li>
                            <li >Request correction of your personal data.</li>
                            <li >Request erasure of your personal data.</li>
                            <li >Object to processing of your personal data.</li>
                            <li >Request restriction of processing your personal
                              data.</li>
                            <li >Request transfer of your personal data.</li>
                            <li >Right to withdraw consent.</li>
                          </ol>
                        </div>
                        <p>If you wish to exercise any of the rights set out
                          above, please
                          <span className="contactlink">contact us.</span></p>
                        <h5>No fee usually required</h5>
                        <p>You will not have to pay a fee to access your
                          personal data (or to exercise any of the other
                          rights). However, we may charge a reasonable fee if
                          your request is clearly unfounded, repetitive or
                          excessive. Alternatively, we may refuse to comply with
                          your request in these circumstances.</p>
                        <h5>What we may need from you</h5>
                        <p>We may need to request specific information from you
                          to help us confirm your identity and ensure your right
                          to access your personal data or to exercise any of
                          your other rights. This is a security measure to
                          ensure that personal data is not disclosed to any
                          person who has no right to receive it. We may also
                          contact you to ask you for further information in
                          relation to your request to speed up our response.</p>
                        <h5>Time limit to respond</h5>
                        <p>We try to respond to all legitimate requests within
                          one month. Occasionally it may take us longer than a
                          month if your request is particularly complex or you
                          have made a number of requests. In this case, we will
                          notify you and keep you updated.
                        </p>
                      </section>
                    </div>
                  </section>
      </div>
    </div>
  </div>

  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingTen">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTen" aria-expanded="false" aria-controls="flush-collapseTen">
        10. Glossary
      </button>
    </h2>
    <div id="flush-collapseTen" className="accordion-collapse collapse" aria-labelledby="flush-headingTen" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
      <section className="row">
                    <div className="col-12">
                      <section className="row">
                        <h5 className="text-strong mt-0" >LAWFUL
                          BASIS</h5>
                        <div>
                          <ul className="text-dark text-strong" style={{listStyleType:'disc'}}>
                            <li>Legitimate Interest
                              <p>means the interest of our business in
                                conducting and managing our business to enable
                                us to give you the best service and the best and
                                most secure experience. We make sure we consider
                                and balance any potential impact on you (both
                                positive and negative) and your rights before we
                                process your personal data for our legitimate
                                interests. We do not use your personal data for
                                activities where our interests are overridden by
                                the impact on you (unless we have your consent
                                or are otherwise required or permitted to by
                                law). You can obtain further information about
                                how we assess our legitimate interests against
                                any potential impact on you in respect of
                                specific activities by
                                <span className="contactlink" >contacting us.</span>
                              </p>
                            </li>
                            <li>Performance of Contract
                              <p>means processing your data where it is
                                necessary for the performance of a contract to
                                which you are a party or to take steps at your
                                request before entering into such a contract.</p>
                            </li>
                            <li>Comply with a legal or regulatory obligation
                              <p>means processing your personal data where it is
                                necessary for compliance with a legal or
                                regulatory obligation that we are subject to.</p>
                            </li>
                          </ul>
                        </div>
                        <h5 className="text-strong">THIRD PARTIES</h5>
                        <div>
                          <ul className="text-dark text-strong" style={{listStyleType:'disc'}}>
                            <li>Internal Third Parties
                              <p>Other companies in the Trailfinders Limited
                                Group acting as joint controllers or processors
                                and who are based in the UK and Ireland and
                                provide IT, service delivery and system
                                administration services and undertake leadership
                                reporting.
                              </p>
                            </li>
                          </ul>

                          <ul className="text-dark text-strong" style={{listStyleType:'disc'}}>
                            <li>
                              External Third Parties
                              <p className="glosssubtext">(i) Suppliers of travel
                                services acting as processors based in the
                                country that you are travelling to and who
                                provide the travel services that make up any
                                booking of travel services that you make with
                                us.
                              </p>
                              <p className="glosssubtext">(ii) Service providers
                                acting as processors based in the United Kingdom
                                who provide IT and system administration
                                services.</p>
                              <p className="glosssubtext">(iii) HM Revenue &amp;
                                Customs, regulators and other authorities acting
                                as processors or joint controllers based in the
                                United Kingdom who require reporting of
                                processing activities in certain circumstances.</p>
                            </li>
                          </ul>
                        </div>

                        <h5 className="text-strong" id="glossary-legal">YOUR LEGAL
                          RIGHTS</h5>
                        <p>You have the right to:</p>
                        <div>
                          <ul className="text-dark text-strong" style={{listStyleType:'disc'}}>
                            <li id="glossary-al1">Request access
                              <p>to your personal data (commonly known as a
                                "data subject access request"). This enables you
                                to receive a copy of the personal data we hold
                                about you and to check that we are lawfully
                                processing it.</p>
                            </li>

                            <li id="glossary-al2">Request correction
                              <p>of the personal data that we hold about you.
                                This enables you to have any incomplete or
                                inaccurate data we hold about you corrected,
                                though we may need to verify the accuracy of the
                                new data you provide to us.</p>
                            </li>

                            <li id="glossary-al3">Request erasure
                              <p>of your personal data. This enables you to ask
                                us to delete or remove personal data where there
                                is no good reason for us continuing to process
                                it. You also have the right to ask us to delete
                                or remove your personal data where you have
                                successfully exercised your right to object to
                                processing (see below), where we may have
                                processed your information unlawfully or where
                                we are required to erase your personal data to
                                comply with local law. Note, however, that we
                                may not always be able to comply with your
                                request of erasure for specific legal reasons
                                which will be notified to you, if applicable, at
                                the time of your request.
                              </p>
                            </li>

                            <li id="glossary-al4">Object to processing
                              <p>of your personal data where we are relying on a
                                legitimate interest (or those of a third party)
                                and there is something about your particular
                                situation which makes you want to object to
                                processing on this ground as you feel it impacts
                                on your fundamental rights and freedoms. You
                                also have the right to object where we are
                                processing your personal data for direct
                                marketing purposes. In some cases, we may
                                demonstrate that we have compelling legitimate
                                grounds to process your information which
                                override your rights and freedoms.</p>
                            </li>

                            <li id="glossary-al5">Request restriction of
                              processing
                              <p>of your personal data. This enables you to ask
                                us to suspend the processing of your personal
                                data in the following scenarios:
                              </p>
                              <p className="glosssubtext">(a) if you want us to
                                establish the data's accuracy;
                              </p>
                              <p className="glosssubtext">(b) where our use of the
                                data is unlawful but you do not want us to erase
                                it;
                              </p>
                              <p className="glosssubtext">(c) where you need us to
                                hold the data even if we no longer require it as
                                you need it to establish, exercise or defend
                                legal claims; or
                              </p>
                              <p className="glosssubtext">(d) you have objected to
                                our use of your data but we need to verify
                                whether we have overriding legitimate grounds to
                                use it.
                              </p>
                            </li>

                            <li id="glossary-al6">Request the transfer
                              <p>of your personal data to you or to a third
                                party. We will provide to you, or a third party
                                you have chosen, your personal data in a
                                structured, commonly used, machine-readable
                                format. Note that this right only applies to
                                automated information which you initially
                                provided consent for us to use or where we used
                                the information to perform a contract with you.
                              </p>
                            </li>

                            <li id="glossary-al7">Withdraw consent at any time
                              <p>where we are relying on consent to process your
                                personal data. However, this will not affect the
                                lawfulness of any processing carried out before
                                you withdraw your consent. If you withdraw your
                                consent, we may not be able to provide certain
                                products or services to you. We will advise you
                                if this is the case at the time you withdraw
                                your consent.</p>
                            </li>
                          </ul>

                        </div>
                      </section>
                    </div>
                  </section>
      </div>
    </div>
  </div>


</div>
</div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-dark p-3 rounded-3" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
    )
}
export default PrivacyModal